'use strict';

angular.module('internal.investigations')
    .controller('InternalInvestigationCorrespondence', ['$scope', '$stateParams', '$state', 'Correspondences', 'MergeFields', '$q', 'MergeContactGroups', 'MergeTemplates', 'MergeObjects', '$rootScope',
        function ($scope, $stateParams, $state, Correspondences, MergeFields, $q, MergeContactGroups, MergeTemplates, MergeObjects, $rootScope) {
        $scope.resetInvestigation();
        $scope.correspondence = $stateParams.investigation_correspondence;
        $scope.correspondenceID = $stateParams.investigationCorrespondenceID;
        $scope.saving = false;
        $scope.deleting = false;
        $scope.loading = true;
        $scope.merge_fields = [];
        $scope.merge_objects = [];
        $scope.contact_groups = [];
        $scope.contacts = [];
        $scope.contactOptions = [];
        $scope.merge_templates = [];
        $scope.documents = [];
        $scope.errorMessage = null;
        
        if ($stateParams.investigationCorrespondenceID != null) {
            Correspondences.getByID($stateParams.investigationCorrespondenceID).then(function (correspondence) {
                $scope.correspondence = correspondence;
                $scope.loading = false;
            })
        }
        else {
            $scope.correspondence = {};
            $scope.correspondence.to_address = [];
            $scope.correspondence.from_address = [];
            $scope.correspondence.cc_address = [];
            $scope.correspondence.bcc_address = [];
            $scope.correspondence.replyto_address = [];

            var a = MergeFields.get('Investigations').then(function (fields) {
                $scope.merge_fields = fields;
            });

            var b = MergeContactGroups.get('Investigations').then(function (groups) {
                $scope.contact_groups = groups
            });

            var c = MergeTemplates.getInvestigationTemplates().then(function (templates) {
                $scope.merge_templates = templates;
            });

            var d = MergeObjects.get('Investigations').then(function (objects) {
                $scope.merge_objects = objects;
            });

            $q.all([a, b, c, d]).then(function () {
                $scope.contact_groups.forEach(function (group) {
                    $scope.contacts.push({ id: group.id, name: group.name, group: true });
                })
                $scope.contactOptions = angular.copy($scope.contacts);
                $scope.loading = false;
            }).catch(function (response) {
                // handle error
            });       
        }

        $scope.setDocuments = function (correspondence) {
            $scope.documents = [];

            $scope.investigation.documents.forEach(function (document) {
                $scope.documents.push({ id: document.id, name: document.name });
            })

            if (correspondence.merge_template != null) {
                correspondence.merge_template.merge_documents.forEach(function (document) {
                    $scope.documents.push({ id: document.document_id, name: document.document_name });
                })
            }
        }

        $scope.$watch('investigationLoading + loading', function () {
            if (!$scope.investigationLoading && !$scope.loading) {
                $scope.setDocuments($scope.correspondence);
                $scope.correspondenceObject = $scope.investigation;
            }
        })

        $scope.save = function () {
            $scope.saving = true;
            $scope.correspondence.merge_entity_id = '96642356-E3E5-4E96-84A5-2D5E7293CF70';
            if ($rootScope.enterprise.settings.email_provider_enabled) {
                $scope.correspondence.from_address = [];
                $scope.correspondence.from_address.push({ id: $rootScope.enterprise.settings.email_provider_from_address, name: $rootScope.enterprise.settings.email_provider_from_address, group: false });
            };
            Correspondences.save($scope.correspondence, { complaintID: $scope.investigationID }).then(function (correspondence) {
                //updateArray($scope.investigation.correspondences, correspondence);
                //updateArray($scope.masterInvestigation.correspondences, correspondence);
                $scope.getInvestigation();
                $state.go('internal.licensing.investigation.correspondences', { id: $scope.investigationID });
                $scope.saving = false;
            })
            .catch(function(reason) {
                if(reason.message) {
                    $scope.errorMessage = reason.message;
                } else {
                    $scope.errorMessage = "An error occurred saving the correspondence.";
                }
                $scope.saving = false;
            });
        }
    }])
;